import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.test';

@Injectable()
export class CountryService {
  private apiCountry = `${environment.IDEMPIER_GATEWAY}/country?`;

  constructor(private http: HttpClient) {}

  list(req: any): Observable<any> {
    return this.http.get(this.apiCountry);
  }

  obtenerTodos(filters: {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDir?: string;
    search?: string;
  }): Observable<any> {
    let url = this.apiCountry;

    if (filters.page !== undefined && filters.size !== undefined) {
      url += `page=${filters.page}&size=${filters.size}&`;
    }

    if (filters.sortBy && filters.sortDir) {
      url += `sortBy=${filters.sortBy}&sortDir=${filters.sortDir}&`;
    }

    if (filters.search) {
      url += `search=${filters.search}`;
    }

    try {
      return this.http.get(url);
    } catch (error) {
      return throwError((error: Error) =>
        console.error(`Error al obtener los paises: ${error}`),
      );
    }
  }
}
